

















import Vue from 'vue'
import { ICategoryFilter } from '../store/state';
import Checkbox from './Checkbox.vue';
import { EventBus } from '../helpers/EventBus.vue';

interface CategoryFilterMethods {
    toTop(): void
}

interface CategoryFilterProperty {
	categoryFilter: ICategoryFilter
}

export default Vue.extend<{}, {}, {} , CategoryFilterProperty>({
	name: 'CategoryFilter',
	props: {
		categoryFilter: {}
	},    
    components: {
        Checkbox
    },
    methods: {
        toTop() {
            //let filter close before scroll
            setTimeout(() => EventBus.$emit('scrollToTop'), 50)
        }
    }
})
